// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"14e9a181","453":"54387f8b","750":"d9edbb84"}[chunkId] + ".chunk.js";
};